const returnSelectors = document.querySelectorAll('.js-return-select')

if (returnSelectors) {
  const activeClass = 'user-area__return-selection--active'
  returnSelectors.forEach((selector) => {
    const input = selector.parentElement.querySelector('input')

    selector.addEventListener('change', (event) => {
      const selected = event.target.value

      if (selected === 'other') {
        input.parentElement.classList.add(activeClass)
        input.value = ''
      } else {
        input.parentElement.classList.remove(activeClass)
        input.value = selected
      }
    })
  })
}
